var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18.5L3 11.75L4.0605 10.6895L9.75 16.3782L19.9395 6.18945L21 7.24995L9.75 18.5Z",
    fill: "#009966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckOutline);
export default __webpack_public_path__ + "static/media/ic-check-outline.c7202ea54c4c9cd6f58969d85cafa4c7.svg";
export { ForwardRef as ReactComponent };